<template>
  <button type="button"  @click="onClick" class="btn w-full rounded-lg bg-green-600 text-green-50 px-4 py-3 font-semibold text-lg leading-tight shadow-md hover:bg-green-100 hover:text-green-600 ">
            <transition name="v-btn-label" mode="out-in">
                <div v-if="loading">
                    <span class="spinner"></span>
                </div>
                <svg v-else-if="success" width="36" height="36" viewBox="0 0 36 36">
                    <path fill="#fff" d="M13.5 24.26L7.24 18l-2.12 2.12 8.38 8.38 18-18-2.12-2.12z" />
                </svg>
                <span v-else>
                    <slot></slot>
                </span>
            </transition>
        </button>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
        },
        success: {
            type: Boolean,
        },
    },
    methods: {
        onClick() {
            this.$emit('click');
        },
    }
}
</script>

<style scoped>
.spinner {
    display: inline-block;
    margin: 0 8px;
    border-radius: 50%;
    width: 1.5em;
    height: 1.5em;
    border: .215em solid transparent;
    vertical-align: middle;
    font-size: 16px;
    border-top-color: var(--ion-color-primary);
    animation: spin 1s cubic-bezier(.55, .15, .45, .85) infinite;
}

.btn {
    min-width: 170px;
    min-height: 42px;
    padding: 0 14px;
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    font-weight: 500;
    color: white;
    transition: background-color 120ms;
    overflow: hidden;
}

.v-btn-label-enter-active {
    animation: slide-in-down 260ms cubic-bezier(.0, .0, .2, 1);
}

.v-btn-label-leave-active {
    animation: slide-out-down 260ms cubic-bezier(.4, .0, 1, 1);
}


@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes slide-in-down {
    0% {
        transform: translateY(-20px);
        opacity: 0;
    }

    50% {
        opacity: .8;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slide-out-down {
    0% {
        transform: translateY(0);
        opacity: 1;
    }

    40% {
        opacity: .2;
    }

    100% {
        transform: translateY(20px);
        opacity: 0;
    }
}
</style>